import { Box, Text } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

function PageSectionTitle({ children }: PropsWithChildren) {
  return (
    <Box my="4">
      <Text as="h3" fontWeight="bold" fontSize="sm">{children}</Text>
    </Box>
  );
}

export default PageSectionTitle;
